import { iconList } from '../../../interfaces/iconlist';
import { Component, inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TagService } from '../../../service/tag.service';

@Component({
    selector: 'app-newandedittag',
    standalone: false,
    templateUrl: './newandedittag.component.html',
    styleUrl: './newandedittag.component.scss'
})
export class NewandedittagComponent {
    readonly data = inject<any>(MAT_DIALOG_DATA);
    readonly dialogRef = inject(MatDialogRef<NewandedittagComponent>);
    isNew = !this.data.tag;
    iconList = iconList || [];
    group: any;
    tagForm: any;

    constructor(
        private _fb: FormBuilder,
        private tagService: TagService
    ) {

        this.tagForm = this._fb.group({
            name: [this.data.tag?.name],
            tagGroupId: [this.data.group?.id],
            icon: [this.data.tag?.icon],
        });

        this.group = this.data.group;

    }

    cancel(event: Event) {
        event.preventDefault();
        this.dialogRef.close();
    }
    clearIcon(event: Event) {
        event.preventDefault();
        this.tagForm.patchValue({ icon: null });
    }
    selectIcon(icon: string) {
        this.tagForm.patchValue({ icon });
    }

    async onSubmit() {
        let addResult
        if (this.isNew == true) {
            addResult = await this.tagService.createTag(this.tagForm.value.name, this.tagForm.value.tagGroupId, this.tagForm.value.icon);
        }

        if (this.isNew === false) {
            addResult = await this.tagService.updateTag(this.data.tag.id, this.tagForm.value.name, this.tagForm.value.tagGroupId, this.tagForm.value.icon);
        }


        if (addResult === false) {
            return;
        }
        this.dialogRef.close(addResult);
    }
}
